// VIEWPORT WIDTHS  (for media queries etc)
// MOBILEVIEW corresponds to width at which BV switches from multi-column to one-column layout

export const PHONE = 500
export const MOBILEVIEW = 1000
